/** @format */

import AppColors from './colors';
import {
  headingOne,
  headingTwo,
  headingThree,
  smallBodyText,
  strongBodyText,
  regularBodyText,
  chartText,
} from './bodyText';
import { latoLight, latoBold, latoRegular, robotoLight, robotoMedium, robotoRegular, robotoBold } from './fonts';
import { Device, ScreenSize } from './deviceBreakpoints';
import Spacing from './spacing';
import { TextSizes } from './bodyText';

/** @deprecated styles are defined in css, not css-in-js. this is all legacy. */
const globalStyles = {
  ...AppColors,
  TextSizes,
  Device,
  ScreenSize,
  Spacing,
  headingOne,
  headingTwo,
  headingThree,
  smallBodyText,
  strongBodyText,
  regularBodyText,
  chartText,
  latoLight,
  latoRegular,
  latoBold,
  robotoLight,
  robotoRegular,
  robotoMedium,
  robotoBold,
};

export default globalStyles;
